import { TRANSACTION_TYPE } from "@/common/const";
import * as userRequest from "@/utils/userRequest";
type Pagination = {
    page: number;
    limit: number;
    type: TRANSACTION_TYPE;
};

export default async function getPackageServiceV2(
    params: Pagination = { page: 1, limit: 3, type: TRANSACTION_TYPE.ALL },
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const data = await userRequest.get("/boost/boost-data-new", {
            params: {
                ...params,
                uid: localStorage.getItem("userIdLocal"),
            },
            headers: {
                "Cache-Control": "public, max-age=10, stale-while-revalidate=3",
            },
        });
        console.log("🚀 ~ getPackageServiceV2 ~ res:", data);
        if (data) {
            onSuccess && onSuccess(data);
            return data;
        }
    } catch (err) {
        console.error("🚀 ~ getPackageServiceV2 ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
